import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'

export default class {
  @observable data = {
    userInfo: {},
    lang: {
      en: {
        rules: "Rules",
        acC: "Activity Content:",
        ruleDesc: `
        There is no gender limit for the activity, all can apply, and all can sign up during the activity time. Unsuccessful users will not be counted in the event data if they perform operations such as mic and ludo after the event starts.
        <br /><br />
        To participate in the application, the user's wealth or charm level must be greater than 5, and leave a 5-star praise in the app store, and submit a screenshot of the praise.
        <br /><br />
        During the event, participants need to complete the weekly designated tasks to get the corresponding rewards. The rewards need to be collected manually, and the mic-on time only counts the mic-on and mic-on time. Exclusive medals can be obtained by completing weekly tasks, and the medals can be upgraded according to the user's completion.
        <br /><br />
        Participants who receive any gift during the event can enter the leaderboard. The list is sorted from high to low according to the received gift value. When users have the same gift value, the user who arrives first will be ranked first. After the event ends, the final reward will be issued according to the ranking .
        <br /><br />
        `,
        copyright: `The event organizer has the right to adjust and interpret the event rules.`,


        reward: "Reward",
        wt: "Weekly Task",
        rank: "Rank",
        mth: "Monday to Thursday",
        fts: "Friday to Sunday",
        pa: "Part A",
        pb: "Part B",
        tm: "Take mic",
        pl: "Play ludo",
        get: "Get",
        reg: "Register",
        un: "user name",
        ui: "user id",
        ul: "user level",
        wealth: "Wealth",
        charm: "Charm",
        htp: "How to play",

        medal: "Medal",
        noOne: "No one on the leaderboard"
      }
    },
  }

  @action async GetUserInfoWeb(uid) {
    let resParams = await http.post('/web/MyAccountInfo', { uid: uid })
    this.data.userInfo = resParams.res
    return resParams
  }

  // 上传参数
  @action async apiGetUploadParams() {
    let data = await http.post('/web/oss/upload  ')
    return data
  }
}


// WEBPACK FOOTER //
// src/store/activity/kingqueen.js